import { hasAccess } from "$root/components/AuthorizationGuard";
import { typedUrlForRoute, useTypedNavigation } from "$root/components/PlatformRouter/RoutesDef";
import { user$ } from "$root/functional-areas/user";
import { readAtom } from "@mdotm/shadcn/legacy/reactivity";
import { PortfolioStudioTab } from "./portfolio-studio-tabs";

export function usePortfolioStudioRedirect(workspaceUuid?: string) {
	const user = readAtom(user$);
	const { push } = useTypedNavigation();
	function navigate() {
		if (hasAccess(user, { requiredService: "SMART_WORKSPACE" })) {
			if (workspaceUuid) {
				push("PortfolioStudio/Workspace", { id: workspaceUuid });
			} else {
				push("PortfolioStudio/DefaultWorkspace", {});
			}
		} else {
			push("PortfoliosStudio", {});
		}
	}

	return { navigate };
}

export function getPortfolioStudioUrl(preselectedInvestments?: string[]) {
	const user = readAtom(user$);
	const preselectedInvestmentsString = preselectedInvestments?.join("|");
	if (hasAccess(user, { requiredService: "SMART_WORKSPACE" })) {
		return typedUrlForRoute("PortfolioStudio/DefaultWorkspace", {
			preselectedInvestments: preselectedInvestmentsString,
		});
	}

	return typedUrlForRoute("PortfoliosStudio", {
		tab: PortfolioStudioTab.Portfolios,
		preselectedInvestments: preselectedInvestmentsString,
	});
}
